import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Layout } from '../utility/Layout';

export function HHIEUserAuthenticatedRoute({ component: Component, isRegistrationComponent, ...rest }) {

    const fetchAuth = async (sfid) => {
        var isAuth = false;
        const result = await fetch('api/admin/GetHhieUserRoleBySfId/' + sfid + '/' + isRegistrationComponent)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (ex) {
                    return console.log("fetchAuthUser", ex);
                }
            })
            .catch(ex => {
                console.log(ex);
            });
        isAuth = result;
        return isAuth;
    };

    return (
        <Route {...rest} render={() => {
            var contents = <Redirect to="logout" />;
            var sfid = "";
            const sessionString = sessionStorage.getItem("user");
            if (sessionString !== null) {
                try {
                    const user = JSON.parse(sessionString);
                    sfid = user.sfid;
                }
                catch (ex) {
                    console.log(ex);
                }
                const isAuthed = Promise.resolve(fetchAuth(sfid));
                contents = isAuthed ? <Layout role="user"><Component /></Layout> : contents;
            }
            return contents;
        }} />
    )
}